<template>
	<div class="content-wrapper">
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item">
					<a href="#">
						<i class="fa fa-home"></i>
						Dashboard
					</a>
				</li>
				<li class="breadcrumb-item active">Monthly Report</li>
			</ol>
		</nav>
		<section class="content">
			<div class="container-fluid">
				<ul class="nav nav-tabs">
					<li class="nav-item">
						<router-link to="/session/monthly" class="nav-link">
							<h6>Session Wise Report</h6>
						</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/session/monthly/month" class="nav-link active">
							<h6>Month Wise Report</h6>
						</router-link>
					</li>
				</ul>
				<div class="row justify-content-md-center">
					<div class="col-sm-12">
						<div class="card">
							<div class="card-header">
								<h3 class="card-title">Monthly Report</h3>
							</div>
							<div class="card-body">
								<div class="row">
									<div class="col-sm-3" v-can="'change_branch'">
										<div class="form-group">
											<label for="from_date">Branch</label>
											<select class="form-control form-control-sm" v-model="meta.branch_id">
												<option value="" disabled>Select Branch</option>
												<option v-for="branch in branches" :key="branch.branch_id"
													:value="branch.branch_id">
													{{ branch.branch_name }}
												</option>
											</select>
										</div>
									</div>
									<div class="col-sm-3">
										<div class="form-group">
											<label for="from_month">From Month</label>
											<input type="month" class="form-control form-control-sm"
												v-model="meta.from_month">
										</div>
									</div>
									<div class="col-sm-3">
										<div class="form-group">
											<label for="to_month">To Month</label>
											<input type="month" class="form-control form-control-sm"
												v-model="meta.to_month">
										</div>
									</div>
									<div class="col-sm-3">
										<div class="form-group" style="margin-top: 26px !important;">
											<button class="btn btn-sm btn-primary mr-2" @click="index"><i
													class="fa fa-search mr-1"></i>Search</button>
											<button class="btn btn-sm btn-danger" @click="discard"><i
													class="fa fa-times mr-1"></i>Discard</button>
										</div>
									</div>
								</div>

								<div class="table-responsive">
									<table class="table table-bordered table-striped table-sm">
										<thead>
											<tr>
												<th class="text-center">#</th>
												<th @click="sort('month')">
													Month
													<span>
														<i v-if="meta.keyword == 'month' && meta.order_by == 'asc'"
															class="fas fa-sort-up"></i>
														<i v-else-if="meta.keyword == 'month' && meta.order_by == 'desc'"
															class="fas fa-sort-down"></i>
														<i v-else class="fas fa-sort"></i>
													</span>
												</th>
												<th class="text-center">Total Days</th>
												<th class="text-center">Total Sessions</th>
												<th class="text-center">Tables</th>
												<th class="text-center">Walkins</th>
												<th class="text-center">Total BuyIn</th>
												<th class="text-center">Avg BuyIn</th>
												<th class="text-center">Rake</th>
												<th class="text-center">GST</th>
												<th class="text-center">Rake %</th>
												<th class="text-center">Expense</th>
												<th class="text-center">Expense %</th>
												<th class="text-center">Tips</th>
												<th class="text-center">Tips %</th>
												<th class="text-center">Avg Gross Rake / Head</th>
												<th class="text-center">Avg Gross Expense / Head</th>
											</tr>
										</thead>
										<tbody>
											<!-- Normal Row -->
											<tr v-for="(report, key) in session_logs" :key="key">
												<td class="text-center">{{ key + 1 }}</td>
												<td>{{ formatMonth(report.year, report.month) }}</td>
												<td class="text-center">{{ report.total_days_in_month }}</td>
												<td class="text-center">{{ report.total_sessions }}</td>
												<td class="text-center">{{ report.active_tables }}</td>
												<td class="text-center">{{ report.walkins }}</td>
												<td class="text-center">{{ $formatCurrency(report.buyins) }}</td>
												<td class="text-center">{{ $formatCurrency(report.avg_buyins) }}</td>
												<td class="text-center">{{ $formatCurrency(report.total_experience_fees)
												}}</td>
												<td class="text-center">{{ $formatCurrency(report.gst || 0) }}</td>
												<td class="text-center">{{ report.experience_fees_per }}%</td>
												<td class="text-center">{{ $formatCurrency(report.expense) }}</td>
												<td class="text-center">{{ report.expense_per }}%</td>
												<td class="text-center">{{ $formatCurrency(report.tips || 0) }}</td>
												<td class="text-center">{{ computeTipsPer(report) }}%</td>
												<td class="text-center">{{ $formatCurrency(computeRakePerHead(report))
												}}</td>
												<td class="text-center">{{
													$formatCurrency(computeExpensePerHead(report)) }}</td>
											</tr>

											<!-- Total Row -->
											<tr>
												<th class="text-center">#</th>
												<th class="text-center">Total</th>
												<th class="text-center">{{ totalDaysAll }}</th>
												<th class="text-center">{{ totalSessionsAll }}</th>
												<th class="text-center">{{ totalActiveTables }}</th>
												<th class="text-center">{{ totalWalkins }}</th>
												<th class="text-center">{{ $formatCurrency(totalBuyins) }}</th>
												<th class="text-center">{{ $formatCurrency(totalAvgBuyins) }}</th>
												<th class="text-center">{{ $formatCurrency(totalExperienceFees) }}</th>
												<th class="text-center">{{ $formatCurrency(totalGst) }}</th>
												<th class="text-center">{{ totalExperienceFeesPer }}%</th>
												<th class="text-center">{{ $formatCurrency(totalExpense) }}</th>
												<th class="text-center">{{ totalExpensePer }}%</th>
												<th class="text-center">{{ $formatCurrency(totalTips) }}</th>
												<th class="text-center">{{ totalTipsPer }}%</th>
												<th class="text-center">{{ $formatCurrency(totalRakePerHead) }}</th>
												<th class="text-center">{{ $formatCurrency(totalExpensePerHead) }}</th>
											</tr>

											<!-- Average Row -->
											<tr>
												<th class="text-center">#</th>
												<th class="text-center">Average</th>
												<th class="text-center">{{ avgDaysAll }}</th>
												<th class="text-center">{{ avgSessionsAll }}</th>
												<th class="text-center">{{ avgActiveTables }}</th>
												<th class="text-center">{{ avgWalkins }}</th>
												<th class="text-center">{{ $formatCurrency(avgBuyins) }}</th>
												<th class="text-center">{{ $formatCurrency(avgAvgBuyins) }}</th>
												<th class="text-center">{{ $formatCurrency(avgExperienceFees) }}</th>
												<th class="text-center">{{ $formatCurrency(avgGst) }}</th>
												<th class="text-center">{{ avgExperienceFeesPer }}%</th>
												<th class="text-center">{{ $formatCurrency(avgExpense) }}</th>
												<th class="text-center">{{ avgExpensePer }}%</th>
												<th class="text-center">{{ $formatCurrency(avgTips) }}</th>
												<th class="text-center">{{ avgTipsPer }}%</th>
												<th class="text-center">{{ $formatCurrency(avgRakePerHead) }}</th>
												<th class="text-center">{{ $formatCurrency(avgExpensePerHead) }}</th>
											</tr>

											<!-- Forecast Row -->
											<tr>
												<th class="text-center">#</th>
												<th class="text-center">Forecast</th>
												<th class="text-center">{{ forecastDaysAll }}</th>
												<th class="text-center">{{ forecastSessionsAll }}</th>
												<th class="text-center">{{ forecastActiveTables }}</th>
												<th class="text-center">{{ forecastWalkins }}</th>
												<th class="text-center">{{ $formatCurrency(forecastBuyins) }}</th>
												<th class="text-center">{{ $formatCurrency(forecastAvgBuyins) }}</th>
												<th class="text-center">{{ $formatCurrency(forecastExperienceFees) }}
												</th>
												<th class="text-center">{{ $formatCurrency(forecastGst) }}</th>
												<th class="text-center">{{ forecastExperienceFeesPer }}%</th>
												<th class="text-center">{{ $formatCurrency(forecastExpense) }}</th>
												<th class="text-center">{{ forecastExpensePer }}%</th>
												<th class="text-center">{{ $formatCurrency(forecastTips) }}</th>
												<th class="text-center">{{ forecastTipsPer }}%</th>
												<th class="text-center">{{ $formatCurrency(forecastRakePerHead) }}</th>
												<th class="text-center">{{ $formatCurrency(forecastExpensePerHead) }}
												</th>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import moment from "moment";
export default {
	name: "Report.MonthlyReport",
	data() {
		return {
			meta: {
				branch_id: this.$store.getters.user.branch_id,
				from_month: "",
				to_month: "",
				order_by: "asc",
				keyword: "month",
			},
			session_logs: [],
			errors: [],
			branches: [],
		};
	},
	mounted() {
		this.getBranches();
		this.discard();
	},
	methods: {
		formatMonth(year, month) {
			return moment(`${year}-${month}`, "YYYY-M").format("MMM-YYYY");
		},
		index() {
			let vm = this;
			let loader = vm.$loading.show();
			vm.$store.dispatch("post", { uri: "getSessionLogsWithMonthlyMonthReport", data: vm.meta })
				.then(function (response) {
					loader.hide();
					vm.session_logs = response.data.reports;
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},
		getBranches() {
			let vm = this;
			vm.$store
				.dispatch("post", { uri: "getBranches" })
				.then(function (response) {
					vm.branches = response.data.data;
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},
		discard() {
			const currentMonthIndex = moment().month();
			const currentYear = moment().year();
			const fyStart = currentMonthIndex < 3
				? moment([currentYear - 1, 3])
				: moment([currentYear, 3]);
			this.meta.from_month = fyStart.format("YYYY-MM");
			this.meta.to_month = moment().format("YYYY-MM");
			this.meta.order_by = "asc";
		},
		sort(field) {
			this.meta.keyword = field;
			this.meta.order_by = this.meta.order_by == 'asc' ? 'desc' : 'asc';
			this.index();
		},
		computeTipsPer(report) {
			const tips = report.tips || 0;
			const rake = report.total_experience_fees || 0;
			return rake != 0 ? ((tips / rake) * 100).toFixed(2) : 0;
		},
		computeRakePerHead(report) {
			const rake = report.total_experience_fees || 0;
			const heads = report.walkins || 0;
			return heads != 0 ? (rake / heads).toFixed(2) : 0;
		},
		computeExpensePerHead(report) {
			const exp = report.expense || 0;
			const heads = report.walkins || 0;
			return heads != 0 ? (exp / heads).toFixed(2) : 0;
		},
	},
	computed: {
		selectedMonthsCount() {
			if (!this.meta.from_month || !this.meta.to_month) return this.numMonths;
			const start = moment(this.meta.from_month, "YYYY-MM");
			const end = moment(this.meta.to_month, "YYYY-MM");
			return end.diff(start, "months") + 1;
		},
		numMonths() {
			if (!this.session_logs || this.session_logs.length === 0) return 0;
			return this.session_logs.length;
		},
		// ----- Totals -----
		totalDaysAll() { return this.session_logs.reduce((t, r) => t + (r.total_days_in_month || 0), 0); },
		totalSessionsAll() { return this.session_logs.reduce((t, r) => t + (r.total_sessions || 0), 0); },
		totalActiveTables() { return this.session_logs.reduce((t, r) => t + (r.active_tables || 0), 0); },
		totalWalkins() { return this.session_logs.reduce((t, r) => t + (r.walkins || 0), 0); },
		totalBuyins() { return this.session_logs.reduce((t, r) => t + (r.buyins || 0), 0); },
		totalAvgBuyins() { return this.session_logs.reduce((t, r) => t + (r.avg_buyins || 0), 0); },
		totalExperienceFees() { return this.session_logs.reduce((t, r) => t + (r.total_experience_fees || 0), 0); },
		totalGst() { return this.session_logs.reduce((t, r) => t + (r.gst || 0), 0); },
		totalExpense() { return this.session_logs.reduce((t, r) => t + (r.expense || 0), 0); },
		totalTips() { return this.session_logs.reduce((t, r) => t + (r.tips || 0), 0); },
		totalExperienceFeesPer() { return this.totalBuyins != 0 ? ((this.totalExperienceFees / this.totalBuyins) * 100).toFixed(2) : 0; },
		totalExpensePer() { return this.totalExperienceFees != 0 ? ((this.totalExpense / this.totalExperienceFees) * 100).toFixed(2) : 0; },
		totalTipsPer() { return this.totalExperienceFees != 0 ? ((this.totalTips / this.totalExperienceFees) * 100).toFixed(2) : 0; },
		totalRakePerHead() { return this.totalWalkins != 0 ? (this.totalExperienceFees / this.totalWalkins).toFixed(2) : 0; },
		totalExpensePerHead() { return this.totalWalkins != 0 ? (this.totalExpense / this.totalWalkins).toFixed(2) : 0; },

		// ----- Averages -----
		avgDaysAll() { return this.selectedMonthsCount != 0 ? (this.totalDaysAll / this.selectedMonthsCount).toFixed(2) : 0; },
		avgSessionsAll() { return this.selectedMonthsCount != 0 ? (this.totalSessionsAll / this.selectedMonthsCount).toFixed(2) : 0; },
		avgActiveTables() { return this.selectedMonthsCount != 0 ? (this.totalActiveTables / this.selectedMonthsCount).toFixed(2) : 0; },
		avgWalkins() { return this.selectedMonthsCount != 0 ? (this.totalWalkins / this.selectedMonthsCount).toFixed(2) : 0; },
		avgBuyins() { return this.selectedMonthsCount != 0 ? (this.totalBuyins / this.selectedMonthsCount).toFixed(2) : 0; },
		avgAvgBuyins() { return this.selectedMonthsCount != 0 ? (this.totalAvgBuyins / this.selectedMonthsCount).toFixed(2) : 0; },
		avgExperienceFees() { return this.selectedMonthsCount != 0 ? (this.totalExperienceFees / this.selectedMonthsCount).toFixed(2) : 0; },
		avgGst() { return this.selectedMonthsCount != 0 ? (this.totalGst / this.selectedMonthsCount).toFixed(2) : 0; },
		avgExpense() { return this.selectedMonthsCount != 0 ? (this.totalExpense / this.selectedMonthsCount).toFixed(2) : 0; },
		avgTips() { return this.selectedMonthsCount != 0 ? (this.totalTips / this.selectedMonthsCount).toFixed(2) : 0; },
		avgExperienceFeesPer() { return this.avgBuyins != 0 ? ((this.avgExperienceFees / this.avgBuyins) * 100).toFixed(2) : 0; },
		avgExpensePer() { return this.avgExperienceFees != 0 ? ((this.avgExpense / this.avgExperienceFees) * 100).toFixed(2) : 0; },
		avgTipsPer() { return this.avgExperienceFees != 0 ? ((this.avgTips / this.avgExperienceFees) * 100).toFixed(2) : 0; },
		avgRakePerHead() { return this.avgWalkins != 0 ? (this.avgExperienceFees / this.avgWalkins).toFixed(2) : 0; },
		avgExpensePerHead() { return this.avgWalkins != 0 ? (this.avgExpense / this.avgWalkins).toFixed(2) : 0; },

		// ----- Forecasts -----
		forecastDaysAll() { return this.selectedMonthsCount != 0 ? ((this.totalDaysAll / this.selectedMonthsCount) * 12).toFixed(0) : 0; },
		forecastSessionsAll() { return this.selectedMonthsCount != 0 ? ((this.totalSessionsAll / this.selectedMonthsCount) * 12).toFixed(0) : 0; },
		forecastActiveTables() { return this.selectedMonthsCount != 0 ? ((this.totalActiveTables / this.selectedMonthsCount) * 12).toFixed(0) : 0; },
		forecastWalkins() { return this.selectedMonthsCount != 0 ? ((this.totalWalkins / this.selectedMonthsCount) * 12).toFixed(0) : 0; },
		forecastBuyins() { return this.selectedMonthsCount != 0 ? ((this.totalBuyins / this.selectedMonthsCount) * 12).toFixed(2) : 0; },
		forecastAvgBuyins() { return this.selectedMonthsCount != 0 ? ((this.totalAvgBuyins / this.selectedMonthsCount) * 12).toFixed(2) : 0; },
		forecastExperienceFees() { return this.selectedMonthsCount != 0 ? ((this.totalExperienceFees / this.selectedMonthsCount) * 12).toFixed(2) : 0; },
		forecastGst() { return this.selectedMonthsCount != 0 ? ((this.totalGst / this.selectedMonthsCount) * 12).toFixed(2) : 0; },
		forecastExpense() { return this.selectedMonthsCount != 0 ? ((this.totalExpense / this.selectedMonthsCount) * 12).toFixed(2) : 0; },
		forecastTips() { return this.selectedMonthsCount != 0 ? ((this.totalTips / this.selectedMonthsCount) * 12).toFixed(2) : 0; },
		forecastExperienceFeesPer() { return this.forecastBuyins != 0 ? ((this.forecastExperienceFees / this.forecastBuyins) * 100).toFixed(2) : 0; },
		forecastExpensePer() { return this.forecastExperienceFees != 0 ? ((this.forecastExpense / this.forecastExperienceFees) * 100).toFixed(2) : 0; },
		forecastTipsPer() { return this.forecastExperienceFees != 0 ? ((this.forecastTips / this.forecastExperienceFees) * 100).toFixed(2) : 0; },
		forecastRakePerHead() { return this.forecastWalkins != 0 ? (this.forecastExperienceFees / this.forecastWalkins).toFixed(2) : 0; },
		forecastExpensePerHead() { return this.forecastWalkins != 0 ? (this.forecastExpense / this.forecastWalkins).toFixed(2) : 0; },
	}
};
</script>
